import React from 'react';
import { Container, Paper } from '@mui/material';

import classes from './NgzSetNewPassword.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { RedirectToMobileApp } from './containers/RedirectToMobileApp/RedirectToMobileApp';
import { RedirectToWebApp } from './containers/RedirectToWebApp/RedirectToWebApp';
import { SetPasswordForm } from './containers/SetPasswordForm/SetPasswordForm';
import { useStepper } from '../../../shared/hooks/useStepper';
import { NgzPageNotFound } from '../../../shared/containers/NgzPageNotFound/NgzPageNotFound';
import { getAccessParamsFromUrl } from '../../../shared/utils/apiUtils';
import { getRouteParam } from '../../../shared/utils/angularUtils';

const NgzSetNewPassword = () => {
  const { activeStep, goToNextStep } = useStepper(0);

  const { accessParams, allParamsExist } = getAccessParamsFromUrl();
  const redirectType = getRouteParam('redirectType');

  if (!allParamsExist) {
    return <NgzPageNotFound />;
  }

  const SuccessRedirect =
    redirectType === 'WEB' ? <RedirectToWebApp /> : <RedirectToMobileApp />;

  const stepsComponent = [
    <SetPasswordForm
      key="set-password-form"
      goToNextStep={goToNextStep}
      accessParams={accessParams}
    />,
    SuccessRedirect,
  ];

  return (
    <Container className={classes.block}>
      <Paper className={classes.scholasticSetNewPassword} variant="roundedBox">
        {stepsComponent[activeStep]}
      </Paper>
    </Container>
  );
};

angularizeWithProviders(NgzSetNewPassword, 'ngzSetNewPassword', {});

export default NgzSetNewPassword;
